// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"e7949e13","260":"171299dd","453":"12c1166f","613":"e427c7b0","741":"994c91b9"}[chunkId] + ".chunk.js";
};